/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCornerLeftUpDouble = createReactComponent("outline", "corner-left-up-double", "IconCornerLeftUpDouble", [["path", { "d": "M18 19h-6a3 3 0 0 1 -3 -3v-7", "key": "svg-0" }], ["path", { "d": "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4", "key": "svg-1" }]]);

export { IconCornerLeftUpDouble as default };
//# sourceMappingURL=IconCornerLeftUpDouble.mjs.map
